export default __webpack_public_path__ + "media/images/features/local_delivery/episode1/admin-2136a7b518fef30ceb8702c0e35e86ee.jpeg";